module.exports = __webpack_public_path__ + "static/media/basicKit__music.36e4462e.jpg";